import { SET_IS_DARK } from "../actions/types";

const initialState = {
   isDark: false
};

const ThemeReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_IS_DARK:
            return { ...state, isDark: payload };

        default:
            return state;
    }
};

export default ThemeReducer;